var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-column fill-height overflow-y-auto",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('v-virtual-scroll', {
    staticClass: "mt-4",
    attrs: {
      "items": _vm.filteredJobs,
      "item-height": "84",
      "bench": "10"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('JobBlock', {
          attrs: {
            "job": item,
            "enableDrop": false
          }
        })];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }